import pxToRem from "assets/theme/functions/pxToRem";

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(11)} ${pxToRem(14)}`,
      borderBottom: "1px solid #F0F3F6",
      fontSize: pxToRem(13),
      color: "#1C2833",
      fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
};

export default tableCell;
